import React from "react"
import { CloseOutlined } from "@ant-design/icons"
import styles from './UploadVideo.module.less';

const Preview = ({ imageUrl, setIsPreview }: any) => {

  return <div className={styles.preview_wapper}>
    <div className={styles.img_wapper}>
      <CloseOutlined className={styles.close_out_lined} onClick={() => setIsPreview(false)} />

      <video style={{ width: "500px" }} muted controls>
        <source src={imageUrl} type="video/mp4" />
      </video>
    </div>
  </div>
}

export default Preview